import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import API from '../../../utils/API';
import SectionHeader from '../../../components/views/SectionHeader';
import SectionFooter from '../../../components/views/SectionFooter';
import DeleteInventoryItemModal from './modals/deleteInventoryItemModal';
import InventoryInfo from './inventoryInfo';
import InventoryAttendees from './inventoryAttendees';
import InventorySessions from './inventorySessions';
import TabsContainer from '../../../components/views/TabsContainer';
import LoadingWizard from '../../../components/spinner/wizard';

class InventoryItem extends Component {
	constructor(props) {
		super(props);
		const { match: { params } } = this.props;

		this.state = {
			item: null,
			editedItem: null,
			DeleteItemModalOpen: false,
			loading: true,
			editing: false,
			selectedSection: 0,
			checkedAttendees: {},
			requiredFields: {
				name: false
			}
		};
	}

	componentDidMount() {
		const { match: { params } } = this.props;
		const { eventId, orgId } = this.props;
		this.setState({ loading: true });
		this.props.setActiveRow(params.inventoryId);

		API().get(`Organizations/${orgId}/events/${eventId}/inventory/${params.inventoryId}`).then((res) => {
			if (res.data) {
				const item = res.data;

				const sessions = this.props.event?.sessions || [];
				const attendees = this.props.event?.attendees || [];

				// Process bookedBy sessions and drop any missing references
				item.bookedBy = Array.isArray(item.bookedBy)
					? item.bookedBy
						.map((bb) => {
						const session = sessions.find((s) => s._id === bb);
						if (!session) return null;
						return {
							_id: session._id,
							name: session.name || '',
						};
						})
						.filter(Boolean)
					: [];

				// Process redeemedBy attendees and drop any missing references
				item.redeemedBy = Array.isArray(item.redeemedBy)
					? item.redeemedBy
						.map((rb) => {
							const attendee = attendees.find((a) => a._id === rb);
							if (!attendee) return null;
							return {
								_id: attendee._id,
								firstName: attendee.firstName,
								lastName: attendee.lastName,
								email: attendee.email,
								phone: attendee.phone,
								company: attendee.company,
								checkedIn: attendee.checkedIn
							};
						})
						.filter(Boolean)
					: [];

				this.setState({
					item: item,
					editedItem: { ...item },
					loading: false
				});
			}
		}).catch((error) => {
			console.error('Error fetching inventory item:', error);
			this.setState({ loading: false });
		});
	}

	saveInfo = () => {
		const { eventId, orgId } = this.props;
		const { editedItem, item } = this.state;
		const requiredFields = this.state.requiredFields;
		let valid = true;
		Object.keys(requiredFields).forEach((key) => {
			if (!editedItem[key] || editedItem[key] === '') {
				requiredFields[key] = true;
				valid = false;
			} else {
				requiredFields[key] = false;
			}
		});
		if (valid) {
			const payloadToSend = { ...editedItem };
			if (payloadToSend.redeemedBy) {
				delete payloadToSend.redeemedBy;
			}
			if (payloadToSend.bookedBy) {
				delete payloadToSend.bookedBy;
			}

			API()
				.patch(`Organizations/${orgId}/events/${eventId}/inventory/${item._id}`, payloadToSend)
				.then((res) => {
					const updatedItem = res.data;
					updatedItem.link = `/${orgId}/events/${eventId}/inventory/${item._id}`;
					updatedItem.total = updatedItem.quantity * updatedItem.price;
					this.props.updateInventory(updatedItem);
					this.setState({
						item: { ...updatedItem },
						editing: false,
						errorMessage: false,
						requiredFields: requiredFields
					});
				})
				.catch((e) => {
					console.log('Error', e);
				});
		} else {
			this.setState({ requiredFields: requiredFields });
		}
	};



	componentWillUnmount() {
		this.props.setActiveRow(null);
	}
	toggleDelete = () => {
		this.setState({ DeleteItemModalOpen: !this.state.DeleteItemModalOpen });
	};

	toggleEditing = (bool) => {
		this.setState({ editing: bool });
	};

	editItemField = (property, value) => {
		const editedItem = this.state.editedItem;
		editedItem[property] = value;
		this.setState({ editedItem: editedItem, editing: true });
	};

	cancelEdit = () => {
		const item = this.state.item;
		const requiredFields = this.state.requiredFields;
		Object.keys(requiredFields).forEach((key) => {
			requiredFields[key] = false;
		});
		this.setState({ editedItem: { ...item }, editing: false, requiredFields: requiredFields });
	};

	addRedeemedByAttendees = (attendees) => {
		const { editedItem } = this.state;
		const updatedAttendees = [...editedItem.redeemedBy, ...attendees];
		this.setState({
			editedItem: {
				...editedItem,
				redeemedBy: updatedAttendees
			}
		});
	}

	removeRedeemedByAttendees = (attendees) => {
		/* attendees will be an array of attendee objects */
		const { editedItem } = this.state;
		const redeemedBy = editedItem.redeemedBy || [];
		const updatedAttendees = redeemedBy.filter((a) => !attendees.includes(a._id));
		this.setState({
			editedItem: {
				...editedItem,
				redeemedBy: updatedAttendees
			}
		});
	}

	addBookedBySessions = (sessions) => {
		const { editedItem } = this.state;
		const updatedSessions = [...editedItem.bookedBy, ...sessions];
		this.setState({
			editedItem: {
				...editedItem,
				bookedBy: updatedSessions
			}
		});
	}

	removeBookedBySessions = (sessions) => {
		const { editedItem } = this.state;
		const bookedBy = editedItem.bookedBy || [];
		const updatedSessions = bookedBy.filter((s) => !sessions.includes(s._id));
		this.setState({
			editedItem: {
				...editedItem,
				bookedBy: updatedSessions
			}
		});
	}

	renderSection = () => {

		const { selectedSection, editedItem } = this.state;
		switch (selectedSection) {
			case 0:
				return <InventoryInfo
					{...this.props}
					editedItem={this.state.editedItem}
					editItemField={this.editItemField}
					requiredFields={this.state.requiredFields}
				/>;
			case 1:
				return <InventoryAttendees {...this.props}
					editedItem={editedItem}
					editItemField={this.editItemField}
					requiredFields={this.state.requiredFields}
					addRedeemedByAttendees={this.addRedeemedByAttendees}
					removeRedeemedByAttendees={this.removeRedeemedByAttendees}

				/>;
			case 2:
				return <InventorySessions {...this.props}
					editedItem={editedItem}
					editItemField={this.editItemField}
					requiredFields={this.state.requiredFields}
					addBookedBySessions={this.addBookedBySessions}
					removeBookedBySessions={this.removeBookedBySessions}

				/>;
			default:
				return <></>;
		}
	}

	updateSelected = (index) => {
		this.setState({ selectedSection: index });
	}

	render() {
		const { DeleteItemModalOpen, editing, item, editedItem, selectedSection, loading } = this.state;
		const { eventId, orgId } = this.props;

		// Don't render anything if still loading or item is null
		if (loading || !item) {
			return (
				<div className="sectionContainer">
					<LoadingWizard text="Loading Inventory Item" loading={loading} />
				</div>
			);
		}

		return (
			<div className="sectionContainer">
				<SectionHeader
					title={`${item.name}`}
					enableLastLink={true}
					subActions={[{ onClick: this.toggleDelete, label: <span><i className='las la-trash mr-10'></i>Delete Item</span> }]}
					closeButton={true}
				>
					<TabsContainer
						tabs={[{ title: 'Information' }, { title: 'Attendees' }, { title: 'Sessions' }]}
						updateSelected={this.updateSelected}
						selectedIndex={selectedSection}
					/></SectionHeader>
				<div className="sectionBody">
					{this.renderSection()}
				</div>
				<SectionFooter
					editing={editing}
					cancelEdit={this.cancelEdit}
					saveEdit={this.saveInfo}
					updatedAt={item.updatedAt}
					lastEditedBy={item.lastEditedBy} />
				{DeleteItemModalOpen &&
					<DeleteInventoryItemModal
						isOpen={DeleteItemModalOpen}
						toggle={this.toggleDelete}
						item={item}
						event={eventId}
						orgId={orgId}
						submit={this.props.deleteInventory}
						deleteSingleItem={this.props.deleteSingleItem}
					/>}
			</div>
		);
	}
}

export default withRouter(InventoryItem);
